import styled from 'styled-components'

export const Button = styled.button`
  background: transparent;
  box-shadow: 0 0 0 transparent;
  border: 0 solid transparent;
  text-shadow: 0 0 0 transparent;
  padding: 0;
  margin-left: 5px;
  position: relative;
  z-index: 1;

  &:hover {
    background: transparent;
    box-shadow: 0 0 0 transparent;
    border: 0 solid transparent;
    cursor: pointer;
    text-shadow: 0 0 0 transparent;
  }
`

export const ToolTipText = styled.span`
  background-color: #000;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  width: 100px;
  padding: 3px 8px;
  position: absolute;
  top: calc(100% + 5px);
  left: -51px;
  text-align: center;

  &:after {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
    content: '';
    margin-left: -5px;
    position: absolute;
    width: 0;
    height: 0;
    top: -5px;
    left: 50%;
  }

  &:before {
    background-color: red;
    content: '';
    width: 14px;
    height: 20px;
    position: absolute;
    top: -20px;
    left: 51px;
    opacity: 0;
  }
`
